const volcanes = {
  payingByMessage: 'الدفع من خلال نظام',
  safePaymentPage: 'صفحة دفع آمنة',
  finishYourPaymentMessage: 'قم بإنهاء عملية الشراء، أكمل عملية الدفع هنا :)',
  inputCustomerName: 'الاسم',
  inputCustomerEmail: 'البريد الإلكتروني',
  inputCustomerPhoneNumber: 'رقم التليفون',
  inputCustumerPhoneNumberOptional: '(خياري)',
  emptyCardSecurityCode: 'أدخل رمز التحقق الخاص ببطاقة الائتمان',
  invalidSecurityCode: 'أدخل رمز التحقق الخاص ببطاقة الائتمان',
  invalidCvv: 'أدخل رمز التحقق الخاص ببطاقة الائتمان',
  fieldCardSecurityCode: 'رمز التحقق من البطاقة (CVV)',
  fieldCardHolderName: 'الاسم بالكامل (كما هو موضح في البطاقة)',
  fieldCardExpiryDate: 'تاريخ الانتهاء',
  placeholderCardExpiryDate: 'شهر/سنة',
  fieldCardNumber: 'رقم البطاقة',
  fieldOneClickCardNumber: '{brand} last {lastFour}',
  transactionFeeTooltip: 'تكاليف المعالجة',
  total: 'الإجمالي',
  amount: 'مبلغ',
  termsLabel: ' بإجراء عملية الدفع، فإنك توافق على',
  termsReferenceLink: ' شروط الخدمه',
  termsEbanxLabel: 'المقدمه من EBANX.',
  paymentPageTitle: 'صفحة الدفع',
  selectPaymentMethod: 'اختر طريقة الدفع',
  fatalErrorTitle: 'عذراً!',
  fatalErrorMessage: 'للأسف لم نتمكن من العثور على بيانات الدفع الخاصة بك.',
  fatalErrorFooter: 'دفع آمن عبر',
  panamaUsdDisclaimer: 'Payments are processed via EBANX. Due to regional routing, your bank statement may reference Panama (PAB), which maintains a fixed 1:1 parity with USD. The final charge should reflect the USD price shown.',
  merchantPaymentCode: '# الطلب',
};

module.exports = volcanes;
